import { render, staticRenderFns } from "./index.vue?vue&type=template&id=63187798&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=63187798&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63187798",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UiInput: require('/app/components/UI/UiInput.vue').default,UiInputWrapper: require('/app/components/UI/UiInputWrapper.vue').default,UiButton: require('/app/components/UI/UiButton.vue').default,UiSpinner: require('/app/components/UI/UiSpinner.vue').default})
